import { Status, VenueType } from '../types/common';
import { GENERAL_CONSTANTS } from '../constants';
import moment from 'moment-timezone';
import _ from 'lodash';
import { useFingerPrint } from '~/components/FingerPrintProvider';
import { useCookies } from 'react-cookie';

const isEventViewable = (eventStatus) => isArchived(eventStatus) || isStreaming(eventStatus);

const isArchived = (eventStatus) =>
  eventStatus === Status.archived || eventStatus === Status.archivedS3;

const isStreaming = (eventStatus) =>
  eventStatus === Status.streaming || eventStatus === Status.streamingFailed;

const isExpired = (eventStatus) =>
  eventStatus === Status.expired ||
  eventStatus === Status.retrieving ||
  eventStatus === Status.retrieved;

const isFuneralHome = (type) => type === VenueType.funeralHome;

const is2StepsPlanAhead = () => eventDataProps.data.venue['plan_ahead_process'] === '2-STEPS';

const isPlanAheadButton = () => eventDataProps.data.venue['plan_ahead_variant'] === 'BUTTON';
const isPlanAheadBanner = () => eventDataProps.data.venue['plan_ahead_variant'] === 'BANNER';
const isLocalViewer = () => {
  const { country } = useFingerPrint() || { country: 'NZ' };
  return eventDataProps.data.venue.country === country;
}
const isPlanAheadAvailable = () => {
  const [cookies] = useCookies(['OneroomAdminAPIToken']);
  return isLocalViewer() && cookies.OneroomAdminAPIToken === undefined;
}

const getLocalnVenueTime = (date, venueTimezone) => {
  const userTimezone = moment.tz.guess();
  const venueLocaltime = moment.tz(date, venueTimezone);
  const userLocaltime = venueLocaltime.clone().tz(userTimezone);

  return { userTimezone, userLocaltime, venueTimezone, venueLocaltime };
};

const convertUTCToVenueTime = (eventData, venueTimezone) => {
  const venueStartTime = moment
    .utc(eventData.start_date)
    .tz(venueTimezone)
    .format(GENERAL_CONSTANTS.DATE_FORMAT);
  const venueEndTime = moment
    .utc(eventData.end_date)
    .tz(venueTimezone)
    .format(GENERAL_CONSTANTS.DATE_FORMAT);

  return { venueStartTime, venueEndTime };
};

const isSameDate = (date1, date2) => {
  return new Date(date1).getTime() === new Date(date2).getTime();
};

const checkIsAbsolute = (url) => {
  return _.startsWith(url, '//') || _.startsWith(url, 'http://') || _.startsWith(url, 'https://')
    ? true
    : false;
};

export {
  isEventViewable,
  isArchived,
  isStreaming,
  isExpired,
  isFuneralHome,
  getLocalnVenueTime,
  convertUTCToVenueTime,
  isSameDate,
  checkIsAbsolute,
  is2StepsPlanAhead,
  isPlanAheadButton,
  isPlanAheadBanner,
  isPlanAheadAvailable,
};
